module.exports = __webpack_public_path__ + "static/media/PeloponnesianWar.3221bdb5.jpg";